import en from './en-US';
import fr from './fr-CA';
import ar from './ar-AR';

export default {
  ...en,
  ...fr,
  ...ar,
};
